<script setup lang="ts">
import type { GridColumnProps } from '@progress/kendo-vue-grid'
import { formatCurrency, roundFloat } from '@/lib/format'
import CardTableContent from '@/components/ui/card/CardTableContent.vue'
import Card from '@/components/ui/card/Card.vue'
import ActiviteCommercialRepository from '@/repository/ActiviteCommercialRepository'
import { ref } from 'vue'
import type { GetRepartitionVisitesViewModel, VisiteDetailViewModel } from '@/lib/types'

const selectedItem = ref<GetRepartitionVisitesViewModel | null>(null)

const columns = [
  { field: 'commercial_name', title: 'Commercial' },
  { field: 'nombre_visites', title: 'Nombre de visites' },
  { field: 'total_visites_client', title: 'Total clients visites' },
  { field: 'visites_per_day', title: 'Ratio visite / jour' },
  { field: 'nombre_propositions', title: 'Nombre de propositions' },
  { field: 'chiffre_affaire_facture', title: "Chiffre d'affaires facturé" },
] as GridColumnProps[]

const detailColumns = [
  { field: 'date_visite', title: 'Date' },
  { field: 'type_visite', title: 'Type de visite' },
  { field: 'client_name', title: 'Client' },
] as GridColumnProps[]

const formatCell = (field: string, value: unknown) => {
  if (field === 'chiffre_affaire_facture') {
    return formatCurrency(value as number)
  }
  if (field === 'visites_per_day') {
    return String(roundFloat(value as number))
  }
  return String(value)
}

const getData = async (
  skip: number,
  take: number,
  sortField: string,
  sortOrder: 'asc' | 'desc',
) => {
  const response = await ActiviteCommercialRepository.getTableData(skip, take, sortField, sortOrder)

  return {
    data: response.data,
    total: response.total,
  }
}

const getDetails = async (
  item: GetRepartitionVisitesViewModel,
  skip: number,
  take: number,
  sortField: string,
  sortOrder: 'asc' | 'desc',
) => {
  const response = await ActiviteCommercialRepository.getTableDetailsData(item.commercial_id, skip, take, sortField, sortOrder)
  return {
    data: response.data as unknown as VisiteDetailViewModel[],
    total: response.total,
  }
}

const getDialogTitle = (item: GetRepartitionVisitesViewModel) => `Détails des visites - ${item.commercial_name}`
</script>

<template>
  <Card
    title="Répartition des visites"
    :download-excel="ActiviteCommercialRepository.downloadExcel"
  >
  <CardTableContent
     v-model:selected-item="selectedItem"
     :columns="columns"
     :detail-columns="detailColumns"
     :get-data="getData"
     :get-details="getDetails"
     :format-cell="formatCell"
     :initial-sort="{ field: 'commercial_name', dir: 'asc' }"
     :details-initial-sort="{ field: 'date_visite', dir: 'asc' }"
     :has-detail="true"
     :dialog-title="selectedItem ? getDialogTitle(selectedItem) : ''"
     detail-button-label="Voir le detail"
   />
  </Card>
</template>
